import React, { useState } from 'react';
import WidgetSlot from './WidgetSlot';

const TOTAL_SLOTS = 12;

function DashboardGrid({ widgets, onSlotClick, onRemoveWidget, onExpandWidget, onMoveWidget, onConfigChange }) {
  const [dragOverPosition, setDragOverPosition] = useState(null);
  const [draggedPosition, setDraggedPosition] = useState(null);

  const handleDragStart = (e, position) => {
    setDraggedPosition(position);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', String(position));
  };

  const handleDragOver = (e, position) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    if (dragOverPosition !== position) {
      setDragOverPosition(position);
    }
  };

  const handleDrop = (e, position) => {
    e.preventDefault();
    const fromPosition = parseInt(e.dataTransfer.getData('text/plain'), 10);
    setDragOverPosition(null);
    setDraggedPosition(null);
    onMoveWidget(fromPosition, position);
  };

  const handleDragEnd = () => {
    setDragOverPosition(null);
    setDraggedPosition(null);
  };

  // Create an array of slot positions (0-11)
  const slots = Array.from({ length: TOTAL_SLOTS }, (_, i) => i);

  return (
    <div className="dashboard-grid">
      {slots.map((position) => {
        const widget = widgets.find(w => w.position === position);
        return (
          <WidgetSlot
            key={position}
            position={position}
            widget={widget}
            onClick={() => onSlotClick(position)}
            onRemove={() => onRemoveWidget(position)}
            onExpand={() => onExpandWidget(position)}
            onConfigChange={onConfigChange}
            isDragOver={dragOverPosition === position}
            isDragging={draggedPosition === position}
            onDragStart={(e) => handleDragStart(e, position)}
            onDragOver={(e) => handleDragOver(e, position)}
            onDrop={(e) => handleDrop(e, position)}
            onDragEnd={handleDragEnd}
          />
        );
      })}
    </div>
  );
}

export default DashboardGrid;
